<template>
  <div class="productservice ">
    <div class="productservice_header ">
      <div class="centre">
        <h3 style="margin-left: 40px;">域贝大数据平台</h3>
        <p class="productservice_header_center" style="margin-left: 40px;">
          以自主研发的第三代瑶池数据仓库为数据存储核心，实现了数据汇集、治理、资产、分析、服务、应用等数据全流程全生命周期大数据平台。
        </p>
        <div class="button" style="margin-left: 40px;" @click="openDialog">联系我们</div>
        <div class="img_box">
          <img class="seal_img" src="../../assets/images/大数据/组21.png" alt="">
          <img class="shink_1" src="../../assets/images/大数据/组22.png" alt="">
          <img class="shink_2" src="../../assets/images/大数据/组24.png" alt="">
          <img class="shink_3" src="../../assets/images/大数据/组23.png" alt="">
          <img class="Pane_1" src="../../assets/images/电子证书/长方块.png" alt="">
          <img class="Pane_2" src="../../assets/images/电子证书/长方块.png" alt="">
          <img class="Pane_3" src="../../assets/images/电子证书/长方块.png" alt="">
          <img class="Pane_4" src="../../assets/images/电子证书/长方块.png" alt="">
        </div>
        <div class="centre heder-bottom">
          <ul>
            <li>
              <div class="main-img">
                <img class="top-img" style="" src="../../assets/images/大数据/大数据动效/形状1433.png" alt="">
                <div class="mubu"></div>
                <img class="img_center_0" style="top: 35px;left: 101px;" src="../../assets/images/大数据/大数据动效/矩形1434.png" alt="">
              </div>
              <p>统一认证</p>
            </li>
            <li>
              <div class="main-img">
                <img style="height:44px;margin-top: 5px;" src="../../assets/images/大数据/大数据动效/组15.png" alt="">
                <img class="img_center_1" style="height:20px;top: 50px;left: 335px;" src="../../assets/images/大数据/大数据动效/形状1439.png" alt="">
              </div>
              <p>统一管理</p>
            </li>
            <li>
              <div class="main-img">
                <img style="height:44px;margin-top: 2px;" src="../../assets/images/大数据/大数据动效/组17.png" alt="">
                <img class="img_center_1" style="height:20px;top: 45px;left: 600px;" src="../../assets/images/大数据/大数据动效/组18.png" alt="">
              </div>
              <p>数据标准</p>
            </li>
            <li>
              <div class="main-img">
                <img style="height:40px;margin-top: 5px;" src="../../assets/images/大数据/大数据动效/组20.png" alt="">
                <img class="img_center" style="top: 43px;left: 842.5px;" src="../../assets/images/大数据/大数据动效/形状1451.png" alt="">
              </div>
              <p>应用互联</p>
            </li>
            <li>
              <div class="main-img">
                <img style="height:28px;margin-top: 5px;" src="../../assets/images/大数据/大数据动效/形状1454.png" alt="">
                <img class="img_center_2" src="../../assets/images/大数据/大数据动效/形状1454拷贝.png" alt=""/>
                <img class="img_center_3" src="../../assets/images/大数据/大数据动效/形状1453.png" alt=""/>
              </div>
              <p>通用服务</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="main-1">
      <div class="centre">
        <p>平台架构</p>
      </div>
      <img class="main-1_right" src="../../assets/images/大数据/架构图.png" alt="">
    </div>
    <div class="main-2">
      <div class="centre">
        <p>竞争优势</p>
        <ul>
          <li>
            <div class="main2-img">
              <img src="../../assets/images/大数据/创新的可视化操控.png" alt="">
            </div>
            <p>创新的可视化操控</p>
            <div class="text_box">
              <p>创新的可视化操控</p>
              <span class="bottom_text">海量、异构、全域的数据汇聚可视化操控，支持数据源一键接入</span>
            </div>
          </li>
          <li>
            <div class="main2-img">
              <img src="../../assets/images/大数据/安全高效的数据共享.png" alt="">
            </div>
            <p>安全高效的数据共享</p>
            <div class="text_box">
              <p>安全高效的数据共享</p>
              <span class="bottom_text">支持数据批量推拉、数据订阅等多种安全高效的数据共享方式</span>
            </div>
          </li>
          <li>
            <div class="main2-img">
              <img src="../../assets/images/大数据/优异的数据搜索能力.png" alt="">
            </div>
            <p>优异的数据搜索能力</p>
            <div class="text_box">
              <p>优异的数据搜索能力</p>
              <span class="bottom_text">基于领先的全文搜索引擎，提供强大的实时流处理和数据检索动力</span>
            </div>
          </li>
          <li style="margin-right: 0px;">
            <div class="main2-img">
              <img src="../../assets/images/大数据/资产化的监控运维.png" alt="">
            </div>
            <p>资产化的监控运维</p>
            <div class="text_box">
              <p>资产化的监控运维</p>
              <span class="bottom_text">便捷的数据质量全生命周期实时监控，以资产管理模式来运维数据</span>
            </div>
          </li>
          <li>
            <div class="main2-img">
              <img src="../../assets/images/大数据/灵活的数据应用能力.png" alt="">
            </div>
            <p>灵活的数据应用能力</p>
            <div class="text_box">
              <p>灵活的数据应用能力</p>
              <span class="bottom_text">利用数据运算以及丰富的服务接口，赋能数据应用场景化需求</span>
            </div>
          </li>
          
        </ul>
      </div>
    </div>
    <div v-show="dialogVisible" class="callUs_dialog">
      <img class="close" src="../../assets/images/电子证书/close.png" alt="" @click="closeDialog" />
      <!-- <div class="dialog_left">
        <div class="center_box">
            <p style="font-size: 20px;">联系我们</p>
            <p style="font-size: 14px;font-weight: 500;margin-top: 15px;">完善信息后我们会第一时间跟您联系</p>
            <div class="line"></div>
            <span>您的称呼：</span>
            <el-input v-model="formLabelAlign.name"></el-input>
            <span>手机号码：</span>
            <el-input v-model="formLabelAlign.tel"></el-input>
        </div>
        <el-button type="primary" @click="onSubmit">提交</el-button>
      </div> -->
      <div class="dialog_right">
        <p>方案咨询</p>
        <img class="erw" src="../../assets/images/电子证书/ewm.png" alt=""/>
        <div class="phone_box">
          <img class="phone" src="../../assets/images/电子证书/phone.png" alt=""/>
          <span>13506670580</span>
        </div>
      </div>
    </div>
    <div v-show="dialogVisible" class="backdrop"></div>
  </div>
</template>

<script>
export default {
  components: {
  },
  data() {
    return {
      dialogVisible: false,
      formLabelAlign: {
        name: '',
        tel: ''
      },
      defferScroll: function (event) {
        event.preventDefault()
      }
    };
  },
  mounted(){
    document.addEventListener('mouseup',(e)=>{
    var button=document.querySelector('.callUs_dialog') //选择返回的第一个出现的元素
    if(button){
        if(!button.contains(e.target)){ //判断某个元素不是目标元素的子元素 即目标元素以外的区域
          this.dialogVisible=false
          this.move()
        }
      }
    })
  },
  methods: {
    onSubmit() {
      this.dialogVisible = false
    },
    openDialog() {
      this.dialogVisible = true
      document.documentElement.scrollTop = 0
      this.stop()
    },
    closeDialog() {
      this.dialogVisible = false
      this.move()
    },
    stop(){
      var mo=function(e){e.preventDefault();};
      document.body.style.overflow='hidden';
      document.addEventListener("touchmove",mo,false);
    },
    move(){
      var mo=function(e){e.preventDefault();};
      document.body.style.overflowY='';
      document.body.style.overflowX='hidden'
      //出现滚动条
      document.removeEventListener("touchmove",mo,false);
    }
  }
};
</script>

<style lang="less" scoped>

.centre {
  width: 1200px;
  margin: 0 auto;
}
.productservice_header {
  height: 670px;
  width: 100%;
  background-image: url('../../assets/images/电子证书/首页图.png');
  padding-top: 200px;
}
.button {
  position: relative;
  width: 131px;
  height: 48px;
  background: linear-gradient(to right, #3186fd , #63a4ff);
  border-radius: 5px;
  // border: 1px solid rgb(51,134,254);
  font-size: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  z-index: 100;
  cursor: pointer;
  &:hover {
    background: linear-gradient(to right, #2170de , #4f98fe);
  }
}
.img_box {
  .seal_img {
    position: absolute;
    width: 625px;
    height: 431px;
    top: 180px;
    left: 47%;
    z-index: 10;
  }
  .shink_1 {
    position: absolute;
    top: 210px;
    left: 53.5%;
    z-index: 11;
    animation: height1 3s infinite;
  }
  .shink_2 {
    position: absolute;
    top: 90px;
    left: 62.5%;
    z-index: 11;
    opacity: 0;
    animation: shink 3.5s infinite;
  }
  .shink_3 {
    position: absolute;
    top: 215px;
    left: 72.7%;
    z-index: 11;
    animation: height2 3.2s infinite;
  }
  .Pane_1 {
    position: absolute;
    width: 92px;
    height: 311px;
    top: 290px;
    left: 1%;
    z-index: 1;
    animation: heightchange1 4s infinite;
  }
  .Pane_2 {
    position: absolute;
    width: 92px;
    height: 311px;
    top: 160px;
    left: 21%;
    z-index: 1;
    animation: heightchange 4s infinite;
  }
  .Pane_3 {
    position: absolute;
    width: 92px;
    height: 311px;
    top: 150px;
    left: 35.1%;
    z-index: 1;
    animation: heightchange2 4.5s infinite;
  }
  .Pane_4 {
    position: absolute;
    width: 92px;
    height: 311px;
    top: 90px;
    left: 45%;
    z-index: 1;
    animation: heightchange3 3.8s infinite;
  }
}
@keyframes height1 {
  0% {
    top: 210px;
  }
  50% {
    top: 190px;
  }
  100% {
    top: 210px;
  }
}
@keyframes height2 {
  0% {
    top: 215px;
  }
  50% {
    top: 200px;
  }
  100% {
    top: 215px;
  }
}
@keyframes shink {
  0% {
    opacity: 0;
  }
  25% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
  75% {
    opacity: 0.5;
  }
  100% {
    opacity: 0;
  }
}
@keyframes heightchange {
  0% {
    top: 160px;
    height: 250px;
  }
  50% {
    top: 130px;
    height: 311px;
  }
  100% {
    top: 160px;
    height: 250px;
  }
}
@keyframes heightchange1 {
  0% {
    top: 290px;
    height: 250px;
  }
  50% {
    top: 320px;
    height: 311px;
  }
  100% {
    top: 290px;
    height: 250px;
  }
}
@keyframes heightchange2 {
  0% {
    top: 200px;
    height: 250px;
  }
  50% {
    top: 170px;
    height: 311px;
  }
  100% {
    top: 200px;
    height: 250px;
  }
}
@keyframes heightchange3 {
  0% {
    top: 140px;
    height: 250px;
  }
  50% {
    top: 110px;
    height: 311px;
  }
  100% {
    top: 140px;
    height: 250px;
  }
}
.productservice_header h3 {
  position: relative;
  font-size: 40px;
  font-weight: 500;
  color: #000;
  margin-bottom: 38px;
  z-index: 100;
}
.productservice_header_center {
  position: relative;
  width: 488px;
  font-size: 14px;
  letter-spacing: 2px;
  margin-bottom: 50px;
  line-height: 25px;
  z-index: 100;
}
.productservice_header button {
  width: 131px;
  height: 48px;
  font-size: 16px !important;
  background-color: linear-gradient(to right, rgb(54,131,253) , rgb(97,163,255));
  font-size: 16px;
  &:hover {
    background-color: #2170de;
  }
}
.productservice_header button span {
  font-size: 16px;
}
// 数据
.heder-bottom {
  // position: absolute;
  transform: translateY(139px);
  height: 140px;
  background-color: #fff;
  padding: 24px 0;
  box-shadow:0 2px 27px 6px rgba(0, 0, 0, .22);
  border-radius: 4px;
  z-index: 999;
}
.heder-bottom ul li {
  float: left;
  display: block;
  width: 20%;
  text-align: center;
  font-size: 16px;
  &:hover {
    .main-img .img_center {
      transform: rotate(360deg);
    }
    p {
      color: #3186fd;
    }
    .mubu {
        animation: mymove 1.5s forwards;
    }
    .img_center_1{
        transform: scale(1.3);
    }
    .img_center_2{
        transform: translateY(10px);
    }
    .img_center_3{
        transform: translateY(-10px);
    }
  }
}
.heder-bottom ul li .main-img {
  display: inline-block;
  width: 56px;
  height: 56px;
  margin-bottom: 16px;
  .img_center{
    position: absolute;
    top: -40px;
    transition: 1s;
    z-index: -1;
  }
  .top-img {
    position: relative;
    height:32px;
    margin-top: 22px;
    z-index: 10;
  }
  .mubu {
    position: absolute;
    width: 50px;
    height: 40px;
    top: 15px;
    left: 100px;
    background-color: #fff;
    transition: .7s;
    z-index: -1;
    transform: rotate(-13deg);
  }
  @keyframes mymove {
    0%{
        z-index: 1;
        left: 100px;
    }
    100%{
        z-index: 1;
        left: 150px;
    }
  }
  .img_center_0{
    position: absolute;
    top: 45px;
    left: 608px;
    transition: .6s;
    z-index: -1;
  }
  .img_center_1{
    position: absolute;
    top: 45px;
    left: 608px;
    transition: .6s;
    z-index: -1;
  }
  .img_center_2{
    position: absolute;
    top: 37.5px;
    left: 1072px;
    transition: .8s;
    z-index: -1;
  }
  .img_center_3{
    position: absolute;
    top: 50px;
    left: 1056px;
    transition: .8s;
    z-index: -1;
  }
}
.main-1 {
  // position: absolute;
  text-align: center;
  width: 100%;
  height: 930px;
//   background-color: rgb(231, 187, 187);
  .arrow {
    position: relative;
    top: -250px;
  }
  .main-1_right{
    transition: 1s;
    &:hover {
      transform: scale(1.1);
    }
  }
}
.main-1 .centre p {
  // margin-top: 148px;
  padding-top: 148px;
  font-size: 30px;
  color: #23405a;
  margin-bottom: 60px;
}
.main-1 .centre img {
  margin-bottom: 60px;
  height: 980px;
}
.main-2 {
  width: 100%;
  height: 500px;
  padding-top: 92px;
  text-align: center;
}
.main-2 .centre p {
  font-size: 30px;
  color: #23405a;
}
.main-2 ul {
  margin-top: 60px;
  display: flex;
  justify-content: space-between;
}
.main-2 ul li {
  position: relative;
  top: 0px;
  list-style: none;
  float: left;
  width: 232px;
  height: 242px;
//   margin-right: 20px;
//   margin-bottom: 20px;
  box-shadow:2px 5px 7px 2px rgba(0, 0, 0, .05);
  cursor: pointer;
  transition: .5s;
  overflow: hidden;
  .text_box {
    position: relative;
    top: 32px;
    width: 232px;
    height: 242px;
    background-color: #ffffff;
    border-top: rgb(49,134,253) 10px solid;
    text-align: center;
    transition: 1s;
    z-index: 10;
    p {
        display: inline-block;
        margin-top: 46px;
        font-size: 18px;
        color: #23450a;
    }
    .bottom_text {
      display: inline-block;
      width: 153px;
      margin-top: 23px;
      line-height: 22px;
      color: #475d73;
      font-size: 14px;
      text-align: justify;
    }
  }
}
.main-2 .centre ul li:hover {
  top: -5px;
  box-shadow:2px 5px 7px 1px rgba(0, 0, 0, .2);
  p {
    color: #3186fd;
  }
  .text_box{
    p {
      color: #000;
    }
    top: -210px;
  }
}
.main2-img {
  width: 159px;
  height: 127px;
  margin: 50px 0 0 36px;
}
.main-2 .centre ul li p {
  margin-top: 16px;
  font-size: 16px;
  color: #23405a;
}
.callUs_dialog {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  width: 300px;
  height: 330px;
  border-radius: 5px;
  z-index: 100000;
  background-color: rgb(243, 150, 150);
  .close {
    position: absolute;
    width: 20px;
    height: 20px;
    top: 10px;
    right: 10px;
    cursor: pointer;
  }
  .dialog_left {
    width: 50%;
    height: 100%;
    float: left;
    background-color: white;
    text-align: center;
    .center_box {
      position: absolute;
      top: 37px;
      left: 33px;
      width: 230px;
      height: 250px;
      display: flex;
      flex-direction: column;
      text-align: left;
      color: black;
      span,.el-input {
        margin-top: 15px;
        font-size: 16px;
      }
    }
    .el-button {
      width: 100px;
      position: relative;
      top: 285px;
    }
    .line {
        height: 5px;
        width: 30px;
        margin-top: 15px;
        border-radius: 5px;
        background-color: rgb(246,65,44);
      }
  }
  .dialog_right {
    width: 100%;
    height: 100%;
    background-color: rgb(49,134,253);
    float: right;
    span {
      font-size: 16px;
    }
    p {
      display: inline-block;
      font-size: 20px;
      color: white;
      font-weight: 100;
      margin-top: 40px;
      margin-left: 25px;
    }
    .erw{
      position: absolute;
      width: 100px;
      height: 100px;
      top: 33%;
    }
    .phone_box {
      position: relative;
      width: 130px;
      height: 20px;
      top: 180px;
      left: 90px;
      display: flex;
      color: white;
      .phone {
        width: 20px;
        height: 20px;
      }
    }
  }
}
.backdrop{
  width:100%;
  height:100%;
  visibility: visible;
  opacity: 1;
  position:fixed;
  top:0;
  right:0;
  bottom:0;
  left:0;
  background: rgba(8, 7, 7, 0.6);
  z-index: 9999;
  // transition: all .2s ease;
  // backdrop-filter: saturate(180%) blur(1px);
}
@media (max-width: 1300px) { 
  .img_box {
    .seal_img {
      position: absolute;
      width: 625px;
      height: 431px;
      top: 180px;
      left: 45%;
      z-index: 10;
    }
    .shink_1 {
      position: absolute;
      top: 210px;
      left: 55%;
      z-index: 11;
      animation: height1 3s infinite;
    }
    .shink_2 {
      position: absolute;
      top: 100px;
      left: 68%;
      z-index: 11;
      opacity: 0;
      animation: shink 3.5s infinite;
    }
    .shink_3 {
      position: absolute;
      top: 215px;
      left: 84%;
      z-index: 11;
      animation: height2 3.2s infinite;
    }
  }
}
</style>
